import ServiceError from './ServiceError';

class ServiceAbort extends ServiceError {
  constructor(error, message = 'Request was cancelled') {
    super(error, message);
  }
}

export default ServiceAbort;
